import DataQuery from 'data/DataQuery';
import { Contract_CapacityGasDraft } from 'data/endpoints';
import { useQuery } from 'data/hooks/useQuery';
import React from 'react';
import ReservedCapacityRow from 'features/contracts/components/reservedCapacity/ReservedCapacityRow';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import CapacityGasDraftDTO from 'features/contracts/dtos/CapacityGasDraftDTO';
import CapacityGasDraft from 'features/contracts/components/reservedCapacity/CapacityGasDraft';
import CapacityGasDraftHeader from 'features/contracts/components/reservedCapacity/CapacityGasDraftHeader';
import { useTranslation } from 'react-i18next';

type Props = {
  contractId: string;
  year: number;
  bottomTitle?: string;
}

const CapacityGasDraftSection = ({ contractId, year, bottomTitle }: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  // fetch data
  const capacityQuery: DataQuery = {
    url: Contract_CapacityGasDraft,
    routeParams: new URLSearchParams([["contractId", contractId!], ["year", String(year)]])
  };
  const { data: capacities, loadStatus } = useQuery<CapacityGasDraftDTO[]>(
    capacityQuery,
    [],
    [contractId, year]
  );

  // sub-renders
  const renderCapacities = () => {
    return capacities.map((item, index) => (
      <ReservedCapacityRow key={index}>
        <CapacityGasDraft
          capacity={item}
        />
      </ReservedCapacityRow>
    ));
  }

  const renderBottomTitle = () => { 
    if (bottomTitle) {
      return <h4 className="text-muted mt-4">{bottomTitle}</h4>;
    }
  }

  // render
  return (
    <NoContentWrapper
      data={capacities}
      loadStatus={loadStatus}
      noContentRender={() => <></>}
    >
      <h4 className="text-muted">{tLabels("capacityGasDraftSection.requiredValues")}</h4>
      <CapacityGasDraftHeader />
      {renderCapacities()}
      {renderBottomTitle()}
    </NoContentWrapper>
  )
}

export default CapacityGasDraftSection;